export const calculateUsage = (data) => {
  const metrics = {
    engagement: {
      usage: data.engagement || data.engagement_users_sold || 0,
      sold: data.engagement_users_sold || 0,
      overage: 0,
      underage: 0
    },
    complete: {
      usage: data.complete || data.complete_used || 0,
      sold: data.complete_users_sold || 0,
      overage: 0,
      underage: 0
    },
    pipeline: {
      usage: data.pipeline || data.pipeline_used || 0,
      sold: data.pipeline_users_sold || 0,
      overage: 0,
      underage: 0
    },
    signature: {
      usage: data.signature || data.signature_used || 0,
      sold: data.signature_users_sold || 0,
      overage: 0,
      underage: 0
    }
  };

  Object.keys(metrics).forEach((key) => {
    const diff = metrics[key].usage - metrics[key].sold;

    metrics[key].overage = Math.max(0, diff);
    metrics[key].underage = Math.max(0, -diff);

    if (metrics[key].sold === 0 && metrics[key].usage > 0) {
      metrics[key].overage = metrics[key].usage;
    }
  });

  if (metrics.complete.underage > 0) {
    let adjustment = Math.min(metrics.complete.underage, metrics.pipeline.overage);
    metrics.pipeline.overage -= adjustment;
    metrics.complete.underage -= adjustment;

    if (metrics.complete.underage > 0) {
      adjustment = Math.min(metrics.complete.underage, metrics.signature.overage);

      metrics.signature.overage -= adjustment;
      metrics.complete.underage -= adjustment;
    }
  }

  if (metrics.pipeline.underage > 0) {
    const adjustment = Math.min(metrics.pipeline.underage, metrics.signature.overage);

    metrics.signature.overage -= adjustment;
    metrics.pipeline.underage -= adjustment;
  }

  Object.keys(metrics).forEach((key) => {
    if (metrics[key].overage > 0) {
      metrics[key].underage = 0;
    } else {
      metrics[key].overage = 0;
    }

    metrics[key].usagePercentage =
      metrics[key].sold > 0
        ? ((metrics[key].usage / metrics[key].sold) * 100).toFixed(0)
        : metrics[key].usage > 0
          ? 100
          : 0;
    metrics[key].overagePercentage =
      metrics[key].sold > 0
        ? ((metrics[key].overage / metrics[key].sold) * 100).toFixed(0)
        : metrics[key].overage > 0
          ? 100
          : 0;
  });

  let totalUsage = 0;
  let totalSold = 0;
  let totalOverage = 0;

  Object.keys(metrics).forEach((key) => {
    if (key !== 'engagement') {
      const { usage, sold, overage } = metrics[key];

      totalUsage += usage;
      totalSold += sold;
      totalOverage += overage;
    }
  });

  let totalUnderage = Math.max(0, totalSold - totalUsage);

  return {
    ...metrics,
    totals: {
      totalUsage,
      totalSold,
      totalOverage,
      totalUnderage,
      totalUsagePercentage: totalSold > 0 ? ((totalUsage / totalSold) * 100).toFixed(0) : totalUsage > 0 ? 100 : 0,
      totalOveragePercentage: totalSold > 0 ? ((totalOverage / totalSold) * 100).toFixed(0) : totalOverage > 0 ? 100 : 0
    }
  };
};
